import axios from "axios";
import { API_URL, getAuthHeader } from ".";

export interface EmailSentListItem {
  id: number;
  dateSent: string | null;
  emailAddress: string | null;
  subject: string | null;
  newsletterId: number | null;
  newsletterName: string | null;
  memberId: number | null;
  memberName: string | null;
  userId: number | null;
  userName: string | null;
  hasHtml: boolean;
}

export interface EmailSentDetail extends EmailSentListItem {
  html: string | null;
}

class EmailsApi {
  static getSent(startDate: string, endDate: string, search?: string) {
    const params = new URLSearchParams();
    params.set("startDate", startDate);
    params.set("endDate", endDate);
    if (search?.trim()) params.set("search", search.trim());
    return axios.get<EmailSentListItem[]>(
      `${API_URL}/api/emails/sent?${params.toString()}`,
      getAuthHeader()
    );
  }

  static getSentDetail(id: number) {
    return axios.get<EmailSentDetail>(
      `${API_URL}/api/emails/sent/${id}`,
      getAuthHeader()
    );
  }
}

export default EmailsApi;
